export default /* css */`
:host {
  --asm-color-default: var(--ui-sys-color-on-surface);
  --asm-color-literal: 14, 91%, 70%;
  --asm-color-number: 14, 91%, 70%;
  --asm-color-register: 221, 100%, 76%;
  --asm-color-string_literal: 42, 100%, 67%;
  --asm-color-character_constant: 42, 100%, 67%;
  --asm-color-immediate_value: 14, 91%, 70%;
  --asm-color-left_paren: 50, 100%, 50%;
  --asm-color-right_paren: 50, 100%, 50%;
  --asm-color-left_curly_brace: 50, 100%, 50%;
  --asm-color-right_curly_brace: 50, 100%, 50%;
  --asm-color-left_brack: 50, 100%, 50%;
  --asm-color-right_brack: 50, 100%, 50%;
  --asm-color-dot: 265, 69%, 75%;
  --asm-color-colon: 265, 69%, 75%;
  --asm-color-operator: 354, 92%, 72%;
  --asm-color-quote: 129, 58%, 91%;
  --asm-color-directive: 265, 69%, 75%;
  --asm-color-opcode: 86, 100%, 75%;
  --asm-color-label: 354, 92%, 72%;
  --asm-color-var: 354, 92%, 72%;
  --asm-color-error-underline: 354, 92%, 50%;

  --font-size: 14px;
  --line-height: 1.5;
  --line-color-active: var(--ui-sys-color-on-surface);
  --container-background-color: 0, 0%, 14%;
  --container-shape: 16px;
  --container-padding: 24px;

  --top-bar-padding-top: 8px;
  --top-bar-padding-bottom: 8px;

  --selection-color: var(--ui-sys-color-surface-variant);
}

[theme="light"] {
  --asm-color-literal: 14, 91%, 50%;
  --asm-color-number: 14, 91%, 50%;
  --asm-color-register: 221, 100%, 56%;
  --asm-color-string_literal: 42, 100%, 37%;
  --asm-color-character_constant: 42, 100%, 57%;
  --asm-color-immediate_value: 14, 91%, 50%;
  --asm-color-left_paren: 50, 100%, 50%;
  --asm-color-right_paren: 50, 100%, 50%;
  --asm-color-left_curly_brace: 50, 100%, 40%;
  --asm-color-right_curly_brace: 50, 100%, 40%;
  --asm-color-left_brack: 50, 100%, 40%;
  --asm-color-right_brack: 50, 100%, 40%;
  --asm-color-dot: 265, 69%, 55%;
  --asm-color-colon: 265, 69%, 55%;
  --asm-color-operator: 354, 92%, 52%;
  --asm-color-quote: 129, 58%, 31%;
  --asm-color-directive: 265, 69%, 45%;
  --asm-color-opcode: 86, 100%, 25%;
  --asm-color-label: 354, 92%, 50%;
  --asm-color-var: 354, 92%, 50%;
  --asm-color-error-underline: 354, 92%, 50%;
}

::slotted(textarea){
  display: none;
}

.editor {
  height: 100%;
  width: 100%;
  min-height: fit-content;
  position: relative;
  padding: calc(var(--ui-sys-unit) * 16) 0;
  counter-reset: line;
  margin: 0;
  font-family: monospace;

  &:before {
    top: 0;
    left: 0;
    height: 100%;
    padding-left: calc(var(--ui-sys-unit) * 16);
    position: absolute;
    content: '';
    width: 40px;
    display: inline-block;
    background-color: hsl(var(--asm-color-default), 0.05);
  }

  &:focus-visible {
    outline: none;
  }

  ::selection {
    background-color: hsl(var(--selection-color));
  }
}

.container {
  height: 100%;
  overflow: auto;
  flex: 1;
}

.line {
  color: hsl(var(--asm-color-default));
  counter-increment: line;
  font-size: var(--font-size);
  line-height: var(--line-height);
  min-height: calc(var(--font-size) * var(--line-height));
  padding: 0 calc(var(--ui-sys-unit) * 16);
  cursor: text;

  &.active {
    background-color: hsl(var(--line-color-active), 0.1);
  }

  &:before {
    user-select: none;
    width: 40px;
    display: inline-block;
    content: counter(line);
    margin-right: 16px;
    color: hsl(var(--ui-sys-color-on-surface), 0.5);
  }
}
.error {
  border-bottom: 1px solid hsl(var(--asm-color-error-underline));
}
.opcode {
  color: hsl(var(--asm-color-opcode));
}
.label {
  color: hsl(var(--asm-color-label));
  font-weight: bold;
}
.var {
  color: hsl(var(--asm-color-var));
}
.literal {
  color: hsl(var(--asm-color-literal));
}
.register {
  color: hsl(var(--asm-color-register));
}
.number {
  color: hsl(var(--asm-color-number));
}
.immediate_value {
  color: hsl(var(--asm-color-number));
}
.directive {
  color: hsl(var(--asm-color-directive));
}
.string_literal {
  color: hsl(var(--asm-color-string_literal));
}
.character_constant {
  color: hsl(var(--asm-color-character_constant));
}
.immediate_value_character_constant {
  color: hsl(var(--asm-color-character_constant));
}
.left_paren {
  color: hsl(var(--asm-color-left_paren));
}
.right_paren {
  color: hsl(var(--asm-color-right_paren));
}
.left_brack {
  color: hsl(var(--asm-color-left_brack));
}
.right_brack {
  color: hsl(var(--asm-color-left_brack));
}
.left_curl_brace {
  color: hsl(var(--asm-color-left_curly_brace));
}
.right_curl_brace {
  color: hsl(var(--asm-color-left_curly_brace));
}
.dot {
  color: hsl(var(--asm-color-dot));
  font-weight: bold;
}
.colon {
  color: hsl(var(--asm-color-colon));
  font-weight: bold;
}
.operator {
  color: hsl(var(--asm-color-operator));
  font-weight: bold;
}
.quote {
  color: hsl(var(--asm-color-quote));
}
.comment {
  opacity: 0.5;
}`